import { Icon } from '@chakra-ui/react';

export default function PieChartIcon(props) {
  return (
    <Icon
      width={4}
      height='17px'
      viewBox='0 0 16 17'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M8 16.3281C3.64844 16.3281 0.03125 12.7109 0.03125 8.35938C0.03125 4 3.64062 0.390625 7.99219 0.390625C12.3516 0.390625 15.9688 4 15.9688 8.35938C15.9688 12.7109 12.3594 16.3281 8 16.3281ZM8 15C9.65625 15 11.1719 14.3984 12.3281 13.4062L7.75 8.92188C7.60156 8.78125 7.5625 8.64062 7.5625 8.46875V1.73438C4.07812 1.95312 1.36719 4.82031 1.36719 8.35938C1.36719 12.0469 4.3125 15 8 15ZM8.60938 7.67969L13.6172 4.80469C12.5469 3.10938 10.7266 1.9375 8.60938 1.74219V7.67969ZM9.04688 8.64062L13.0938 12.6406C14.0625 11.4844 14.6406 9.99219 14.6406 8.35938C14.6406 7.42188 14.4531 6.53906 14.1094 5.73438L9.04688 8.64062Z' />{' '}
    </Icon>
  );
}
